import mapboxgl from 'mapbox-gl'

window.mapJs = {};

(function (mapJsApp) {

    mapJsApp.InitializeMap = function () {

        if ($("#map-container").length) {
            let mapDiv = $("#map-container");
            mapboxgl.accessToken = mapDiv.data("accesstoken");
            let latitude = mapDiv.data("latitude");
            let longitude = mapDiv.data("longitude");
            let zoom = mapDiv.data("zoom");

            const map = new mapboxgl.Map({
                container: 'map-container',
                style: mapDiv.data("styleurl"),
                center: [longitude, latitude],
                zoom: zoom,
                cooperativeGestures: true
            });

            map.addControl(new mapboxgl.NavigationControl());

            mapDiv.siblings("#map-markers").find(".marker").each(function () {
                let element = document.createElement('div');
                element.className = 'map-marker';
                element.innerHTML = document.getElementById('marker-icon').innerHTML;

                if ($(this).attr('id') != undefined) element.id = $(this).attr('id');

                latitude = $(this).data("latitude");
                longitude = $(this).data("longitude");

                const markerCoordinates = [longitude, latitude];
                let marker = new mapboxgl.Marker(element)
                    .setLngLat(markerCoordinates);

                if ($(this).find(".popup-content").length) {
                    let popup = new mapboxgl.Popup({ offset: 25, maxWidth: 'none', focusAfterOpen: false, closeButton: false })
                        .setHTML($(this).find(".popup-content").html());
                    marker.setPopup(popup);
                }

                marker.addTo(map);
                $(this).remove();
            });


            $("#map-container").on("click", ".js-close-popup", function () {
                $('.mapboxgl-popup').remove();
            });

            map.on('load', () => {
                // Add a data source containing GeoJSON data.
                map.addSource('wq', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Polygon',
                            // These coordinates outline Wynyard Quarter.
                            'coordinates': [
                                [
                                    [174.75159712236893, -36.844161736418826],
                                    [174.7519831303916, -36.84337101046714],
                                    [174.75209578272793, -36.84340106146627],
                                    [174.75249274266807, -36.84250382113881],
                                    [174.7523755936336, -36.84236098374598],
                                    [174.75254249595537, -36.84211911213903],
                                    [174.7526417355504, -36.84215160202595],
                                    [174.7537356373671, -36.83960376702203],
                                    [174.7539093067128, -36.83965611409994],
                                    [174.75397584358433, -36.839638512651675],
                                    [174.75403110231917, -36.839589775513616],
                                    [174.75409980929425, -36.83958617204797],//[174.75405140143906, -36.839539233260844],
                                    [174.75740748572727, -36.836693017615765],//[174.75735113248822, -36.83664256568526],
                                    [174.75925060181814, -36.8364166323333],
                                    [174.75984548189842, -36.83687614948242],
                                    [174.75784555370993, -36.838668799925934],
                                    [174.75783653181782, -36.83871212246631],
                                    [174.75786021414496, -36.838744614390336],
                                    [174.75790081247825, -36.838759957807405],
                                    [174.75794704948402, -36.83876176291152],
                                    [174.75995891910836, -36.83701981807736],
                                    [174.75999500631949, -36.83699725368816],
                                    [174.7600107945448, -36.83700266905618],
                                    [174.76014161177758, -36.83710465901568],
                                    [174.75850222374206, -36.83854651444393],
                                    [174.75849283605578, -36.83857012754696],
                                    [174.75849484772232, -36.83857817746247],
                                    [174.75850624711654, -36.83858783735111],
                                    [174.75829837590052, -36.83877298549234],
                                    [174.75829569368827, -36.838771912168696],
                                    [174.7582742359806, -36.83877191215406],
                                    [174.75820986312465, -36.83881591822851],
                                    [174.75662957317115, -36.84021441130834],
                                    [174.75663359648613, -36.84021816786322],
                                    [174.7566470075361, -36.84025305015178],
                                    [174.75661482097087, -36.84028363922949],
                                    [174.756732167809, -36.84028417586517],
                                    [174.75675228441824, -36.84028954235866],
                                    [174.7567683776938, -36.840284712490806],
                                    [174.75684079747606, -36.840286322360356],
                                    [174.75686292533746, -36.84030617841694],
                                    [174.75683878549717, -36.84036359989069],
                                    [174.75685219654653, -36.84036735642952],
                                    [174.75683610331345, -36.8404215580044],
                                    [174.7583857499184, -36.84082753070844],
                                    [174.75642241263074, -36.84586809889503],
                                    [174.75288183323414, -36.845000912984],
                                    [174.75159712236893, -36.844161736418826]
                                ]
                            ]
                        }
                    }
                });
                
                map.addLayer({
                    'id': 'outline',
                    'type': 'line',
                    'source': 'wq',
                    'layout': {},
                    'paint': {
                        'line-color': '#F15C22',
                        'line-width': 2,
                        'line-dasharray': [2, 2]
                    }
                });
            });
        }
    }

    $(document).ready(function () {

        mapJsApp.InitializeMap();

    }); // document ready
})(window.mapJs);
